document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-skylrk-hero]').forEach((hero) => {
    const grid = hero.querySelector('.skylrk-hero__grid');
    const tiles = hero.querySelectorAll('[data-skylrk-tile]');
    const defaultBg = hero.style.getPropertyValue('--skylrk-hero-default-bg') || '#F7F5F2';
    const canHover = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

    const setActiveBg = (color) => {
      hero.style.backgroundColor = color;
      document.documentElement.style.setProperty('--skylrk-active-bg', color);
      document.documentElement.setAttribute('data-hero-active-bg', color);
    };

    setActiveBg(defaultBg);

    if (!canHover || !tiles.length || !grid) return;

    const activate = (tile) => {
      const color = tile.getAttribute('data-hover-color') || defaultBg;
      setActiveBg(color);
      grid.setAttribute('data-hover-active', '');
      tile.setAttribute('data-active', '');
    };

    const deactivate = (tile) => {
      setActiveBg(defaultBg);
      grid.removeAttribute('data-hover-active');
      tile.removeAttribute('data-active');
    };

    tiles.forEach((tile) => {
      tile.addEventListener('pointerenter', () => activate(tile));
      tile.addEventListener('pointerleave', () => deactivate(tile));
      tile.addEventListener('focus', () => activate(tile));
      tile.addEventListener('blur', () => deactivate(tile));
    });
  });
});
